import React from "react";

import type { IconProps } from "./types";

const PhoneIcon: React.FC<IconProps> = ({ size = 19, stroke = "currentColor" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={stroke} 
    stroke-width="1" 
    stroke-linecap="round" 
    stroke-linejoin="round" 
    className="lucide lucide-phone-icon lucide-phone">
      <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/>
  </svg>
);

export default PhoneIcon;
